import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NxDialogService, NxModalConfig } from '@allianz/ng-aquila/modal';
import { ConfirmationModalComponent } from './confirmation-modal.component';
import { ConfirmationModalConfig } from './confirmation-modal.model';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ConfirmationModalService {
  private nxDialogService = inject(NxDialogService);

  open(config: ConfirmationModalConfig, modalConfig: NxModalConfig = {}): Observable<boolean> {
    return this.nxDialogService
      .open<ConfirmationModalComponent, ConfirmationModalConfig, boolean>(ConfirmationModalComponent, {
        data: config,
        showCloseIcon: false,
        panelClass: 'custom-modal',
        ...modalConfig,
      })
      .afterClosed()
      .pipe(map(Boolean), take(1));
  }
}
